package com.trevorwiebe.timesheet.loads.presentation.admin

import androidx.compose.runtime.Composable
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.trevorwiebe.timesheet.admin.loadrate.domain.model.LoadRate
import com.trevorwiebe.timesheet.mileage.domain.model.Location

@Composable
internal actual fun LoadRateSearchDialog(
    loadRates: List<LoadRate>,
    suggested: List<LoadRate>,
    locations: List<Location>,
    onSelect: (LoadRate?) -> Unit,
    onDismiss: () -> Unit,
) {
    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(usePlatformDefaultWidth = false)
    ) {
        LoadRateSearchContent(
            loadRates = loadRates,
            suggested = suggested,
            locations = locations,
            onSelect = onSelect,
            onDismiss = onDismiss
        )
    }
}
